import { ArrowRight } from "lucide-react";
import { Reveal, useScrollTo, openSchedule } from "./Reveal";

const FinalCTA = () => {
  const scrollTo = useScrollTo();
  return (
    <section className="relative bg-white bg-blueprint py-32 lg:py-48 overflow-hidden" data-testid="final-cta-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 text-left">
        <Reveal>
          <div className="font-mono text-[11px] tracking-[0.4em] text-skope uppercase">The Next Step</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display font-bold text-[14vw] sm:text-7xl lg:text-8xl xl:text-9xl tracking-tighter leading-[0.95] text-ink" data-testid="final-cta-headline">
            BUILDING A<br /><span className="text-outline-blue">FOOD BRAND?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-ink/55 text-base lg:text-lg leading-relaxed">
            Let's build the kitchen and operating system behind it.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => openSchedule()}
              className="group flex items-center justify-center gap-3 bg-skope text-ink font-mono text-xs tracking-[0.2em] uppercase px-10 py-5 hover:bg-ink hover:text-white transition-colors duration-300"
              data-testid="final-cta-schedule"
            >
              Schedule a Call
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              onClick={() => scrollTo("#calculator")}
              className="flex items-center justify-center gap-3 border border-ink/25 text-ink font-mono text-xs tracking-[0.2em] uppercase px-10 py-5 hover:border-skope hover:text-skope transition-colors duration-300"
              data-testid="final-cta-calculator"
            >
              Calculate Your Kitchen
            </button>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-10 flex flex-col sm:flex-row gap-5 sm:gap-10">
            <a href="mailto:contact@skopekitchens.com" className="inline-block font-mono text-sm text-ink/40 hover:text-skope transition-colors tracking-[0.1em]" data-testid="final-cta-email">
              contact@skopekitchens.com
            </a>
            <a href="tel:+918618689724" className="inline-block font-mono text-sm text-ink/40 hover:text-skope transition-colors tracking-[0.1em]" data-testid="final-cta-phone">
              +91 8618689724
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
